// TODO: Later: Make this a panel against ArtifactVersion

import * as Panel2 from '@wandb/weave/components/Panel2/panel';
import {
  opArtifactName,
  opArtifactProject,
  opArtifactTypeName,
  opArtifactVersionArtifactSequence,
  opArtifactVersionArtifactType,
  opArtifactVersionHash,
  opArtifactVersionId,
  opDict,
  opEntityName,
  opProjectEntity,
  opProjectName,
  OutputNode,
} from '@wandb/weave/core';
import {useNodeValue} from '@wandb/weave/react';
import * as React from 'react';

import ArtifactDag from '../../ArtifactLineageDag/ArtifactDag';

const inputType = 'artifactVersion' as const;
type ConfigType = {};

export const PanelArtifactVersionLineage: React.FC<
  Panel2.PanelProps<typeof inputType, ConfigType>
> = ({input: artifactVersionNode}) => {
  const {result, loading} = useNodeValue(
    React.useMemo(() => {
      // Here we do extra walks to guarantee we are looking at the sequence flavour
      // to ensure there is a hash to use for the dag.
      const artifactNode = opArtifactVersionArtifactSequence({
        artifactVersion: artifactVersionNode,
      });
      const projectNode = opArtifactProject({artifact: artifactNode});

      return opDict({
        artifactTypeName: opArtifactTypeName({
          artifactType: opArtifactVersionArtifactType({
            artifactVersion: artifactVersionNode,
          }),
        }),
        entityName: opEntityName({
          entity: opProjectEntity({project: projectNode}),
        }),
        projectName: opProjectName({
          project: projectNode,
        }),
        artifactSequenceName: opArtifactName({
          artifact: artifactNode,
        }),
        commitHash: opArtifactVersionHash({
          artifactVersion: artifactVersionNode,
        }),
        versionId: opArtifactVersionId({
          artifactVersion: artifactVersionNode,
        }),
      } as any) as unknown as OutputNode<'any'>;
    }, [artifactVersionNode])
  );

  // When an anon user (not logged in) tries to view a private artifact's lineage, artifactTypeName and
  // artifactSequenceName will be null. ['private' meaning that the artifact belongs to a private project].
  if (
    loading ||
    result == null ||
    result.artifactTypeName == null ||
    result.artifactSequenceName == null
  ) {
    return <></>;
  }
  return (
    <ArtifactDag
      entityName={result.entityName}
      projectName={result.projectName}
      artifactTypeName={result.artifactTypeName}
      artifactCollectionName={result.artifactSequenceName}
      artifactCommitHash={result.commitHash}
      artifactVersionID={result.versionId}
    />
  );
};
